import { Component, Input, Output, OnInit, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-barcode-charge-modal',
  templateUrl: './barcode-charge-modal.component.html',
  styleUrls: ['./barcode-charge-modal.component.scss']
})
export class BarcodeChargeModalComponent implements OnInit {
  @ViewChild('custBarcodeInput') custBarcodeInput: ElementRef;
  isShowBarcodeChargeModal = false;
  barcodeChargeSpinning = false;
  custBarcode: any = null;
  @Input()
  set settingVisible(v) {
    this.isShowBarcodeChargeModal = v;
  }

  get settingVisible() {
    return this.isShowBarcodeChargeModal;
  }

  @Input()
  set settingSpinning(v) {
    this.barcodeChargeSpinning = v;
  }

  get settingSpinning() {
    return this.barcodeChargeSpinning;
  }

  @Output() modalStatus = new EventEmitter();
  @Output() startDoCharge = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  handleBarcodeCharge(event) {
    if (this.barcodeChargeSpinning === true) {
      return;
    }
    if (event.keyCode === 13) {
      event?.preventDefault();
      this.custBarcodeInput?.nativeElement.blur();
      this.barcodeChargeSpinning = true;
      // this.handleCharge('scanPay');
      this.startDoCharge.emit(this.custBarcode);
      return false;
    }
  }

  onFocusBarcodeInput() {
    setTimeout(() => {
      this.custBarcodeInput?.nativeElement.focus();
    }, 500);
  }


  closeBarcodeModal(event) {
    this.barcodeChargeSpinning = false;
    this.modalStatus.emit(false);
    this.custBarcode = null;
  }

}
